import {useState} from "react";
import React from "react";
import icons from "../helpers/icons";
import {extractDateAndMonth, extractYear} from '../helpers/util';
import VismerKnappen from '../components/VismerKnappen';



const UtenlandskeResultater = (props) => {
    const resultater = props.resultater || [];
    const className = props.className;

    const [resultaterVises, setResultaterVises] = useState(5)

    const rows = resultater.map((resultat) => (
        <Resultat key={resultat.id} resultat={resultat} />
    )).splice(0, resultaterVises);

    return (
        <div className={className}>

            {rows}
            {resultater.length === 0 &&
            <div>&nbsp;</div>
            }

            <VismerKnappen
                total={resultater.length}
                maxStep="5"
                renderedAmount={resultaterVises}
                incrementer={setResultaterVises}
            />
        </div>
    );
};


const Resultat = (props) => {
    const resultat = props.resultat;
    const [showDetaljer, setShowDetaljer] = useState(false);
    // const [showKritikk, setShowKritikk] = useState(false);

    const dokumenter = resultat.vedleggList.map((vedlegg) => (
        <li key={vedlegg.id}><a href={vedlegg.url} className="document-link" rel="noopener noreferrer" target="_blank">{vedlegg.navn}</a></li>
    ));


    const toggleDetaljer = () => {
        if (showDetaljer) {
            setShowDetaljer(false);
        }else {
            setShowDetaljer(true);
        }
    }


    const detaljer = (
        <div className="line-info" >
            <div className="splitt-line"></div>
            <ul className="dogweb-details">
                { resultat.dommer !== null &&
                    <li><span>Dommer:</span> {resultat.dommer}</li>
                }
                {dokumenter}
            </ul>
        </div>

    );

    return (
        <div>
            <button onClick={toggleDetaljer} className="line">
                <div className="place">
                    <div className="date">{extractDateAndMonth(resultat.bedoemmelseDato)}</div>
                    <div className="location clip">{resultat.sted}</div>
                    <div className="score clip">
                            <span>
                                <img className="icon" src={icons.score} alt="" />
                            </span>
                            {resultat.resultat}
                    </div>
                </div>
                <div className="club">
                    <div className="year">{extractYear(resultat.bedoemmelseDato)}</div>
                    <div className="club-name clip">{resultat.arrangoerNavn}</div>
                    <div className="arrow">
                        <img className="icon" src={icons.acd} alt="" data-open={showDetaljer}/>
                    </div>
                </div>
            </button>
            { showDetaljer && detaljer}

        </div>
    );


};

export default UtenlandskeResultater;
